import request from '@/service/request'

export const getRecruitList = (params: HOME.RECRUIT_PARAMS) => {
  return request<SERVICE.ResponsePage<HOME.RECRUIT[]>>({
    url: '/admin/user-application/page',
    method: 'GET',
    params
  })
}

export const updateRecruitStatus = (id: string) => {
  return request<SERVICE.Response<string>>({
    url: `/admin/user-application/${id}/process`,
    method: 'PUT'
  })
}

export const delRecruitById = (id: string) => {
  return request<SERVICE.Response<string>>({
    url: `/admin/user-application/${id}`,
    method: 'DELETE'
  })
}
